
<template>

  <div class="record_box"
       :class="{'bg':!isEmpty}">
    <div class="line"
         v-if="!isEmpty"></div>
    <div class="record_item"
         v-if="!isEmpty">
      <div class="box"
           v-for="(item,index) in list"
           :key="index">
        <div class="look_limit">
          <img class="logo"
               :src="item.iconUrl" />
          <span class="name">{{item.name}}</span>
          <span class="limit"
                @click="showCoins(item)">+ {{item.price}} <span class="coins"></span></span>
        </div>
      </div>
    </div>
    <Empty :propJson="propJsonEmpty"
           v-else />
    <VueLottie :propJson="propJson"
               @toHideGif="toHideGif"
               ref="vueLottie" />
  </div>
</template>

<script>
import Empty from '@/components/empty'
import VueLottie from '../../components/vueLottie';
export default {
  components: {
    VueLottie,
    Empty
  },
  data () {
    return {
      list: [],
      money: '',
      isEmpty: false,
      propJson: {
        isShow: false,
        price: '10'
      },
      propJsonEmpty: {
        title: '金币已经领完啦~快去赚金币吧！',
      },
    }
  },
  mounted () {
    this.util.title('待领取金币列表');
    this.getList();
  },
  methods: {
    toHideGif () {
      this.propJson.isShow = false;
      this.$refs.vueLottie.anim.stop();
    },
    showCoins (item) {
      this.getCoins(item);
      this.propJson.price = item.price
      this.propJson.isShow = true
      this.$refs.vueLottie.anim.play();
      this.$refs.vueLottie.failAudio.play()
      let _this = this;
      setTimeout(() => {
        _this.toHideGif();
      }, 2000)
    },
    //领取金币接口
    getCoins (item) {
      let _this = this;
      this.$post('/app/valueAdded/receiveGold/' + item.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.getList();
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    getList () {
      let _this = this;
      this.$get('/app/valueAdded/receivableTasks', {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.list = e.data;
            if (_this.list.length > 0) {
              _this.isEmpty = false;
            } else {
              _this.isEmpty = true;
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },

  }
}
</script>
<style scoped>
.record_box {
  font-family: PingFangSC-Regular;
  background: #f7f7f7;
}
.line {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.bg {
  background: #fff;
}
.record_item {
  background: #fff;
  padding: 0.2rem 0.15rem;
}
.look_limit {
  line-height: 0.37rem;
  display: flex;
  height: 0.37rem;
  margin-bottom: 0.18rem;
}

.pd {
  color: #999;
  font-size: 0.12rem;
}
.name {
  font-size: 0.14rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 400;
}
.logo {
  display: inline-block;
  width: 0.37rem;
  height: 0.37rem;
  margin-right: 0.08rem;
}
.limit {
  width: 0.7rem;
  height: 0.3rem;
  background: linear-gradient(
    135deg,
    rgba(255, 172, 85, 1) 0%,
    rgba(255, 57, 31, 1) 100%
  );
  box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
  border-radius: 15px;
  position: absolute;
  right: 0.15rem;
  color: #fff;
  font-size: 0.12rem;
  line-height: 0.3rem;
  text-align: center;
}
.bank_icon,
.people_icon,
.safe_icon,
.apply_icon,
.email_icon,
.phone_icon,
.task_icon {
  display: inline-block;
  width: 0.37rem;
  height: 0.37rem;
  /* background: url("../../assets/img/vipActive/bank_auth.png") no-repeat center
    center; */
  background-size: 100% 100%;
}
.people_icon {
  background: url("../../assets/img/vipActive/people_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.safe_icon {
  background: url("../../assets/img/vipActive/safety_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.apply_icon {
  background: url("../../assets/img/vipActive/apply_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.bank_icon {
  background: url("../../assets/img/vipActive/bank_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.email_icon {
  background: url("../../assets/img/vipActive/email_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.task_icon {
  background: url("../../assets/img/vipActive/task_auth.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.coins {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("../../assets/img/vip/luck/coins1.png") no-repeat center
    center;
  background-size: 100% 100%;
  position: relative;
  top: 0.03rem;
}
.redDw {
  color: #ff514a;
  font-size: 0.14rem;
}
.grayDw {
  color: #666;
  font-size: 0.14rem;
}
.opacity {
  opacity: 0.4;
}
.mescroll-empty {
  padding-top: 0.1rem;
  text-align: center;
}
.empty-tip {
  margin-top: 6px;
  font-size: 0.15rem;
  color: #ccc;
}
.empty-tip .empty-img {
  margin: 0 auto;
  width: 1.43rem;
  height: 1.22rem;
  margin-top: 1.14rem;
}
</style>
